import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { propShape, propStr } from '../../../helpers/custom-prop-types';
import { getFormShowError } from '../../../helpers/form';
import HocFormName from './HocFormName';
import InputError from './InputError';
const InputErrorWithConnect = (props) => {
    const { className, name, thisForm } = props;
    const formError = getFormShowError(thisForm, name);
    return _jsx(InputError, { className: className, error: formError });
};
InputErrorWithConnect.propTypes = {
    className: propStr(),
    name: propStr().isRequired,
    thisForm: propShape(),
};
InputErrorWithConnect.defaultProps = {
    className: '',
    thisForm: {},
};
const mapStateToProps = (state, { form }) => ({
    thisForm: state.form[form],
});
const enhance = compose(HocFormName, connect(mapStateToProps));
export default enhance(InputErrorWithConnect);
